import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { BaseUrl } from "../../helper/BaseUrl";
import CustomSelect from "../../component/CustomSelect";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const EditEndpoint = ApiEndpoints.pr.Edit;
const UpdateEndpoint = ApiEndpoints.pr.Update;
const filterfetchEndpoint = ApiEndpoints.filters.List;

export default function EditPr() {
  const navigate = useNavigate();
  const { pressrelease_id } = useParams();

  const [filters, setFilters] = useState([]);
  const [previews, setPreviews] = useState({ banner_image: null, thumbnail: null, });
  const [selectedTags, setSelectedTags] = useState([]);

  const [postData, setPostData] = useState({ author_id: "", specialty_id: "", provider_id: "", solution_id: "", tag1: "", date: new Date(), title: "", slug: "", banner_image: null, alt_banner_image: "", thumbnail: null, alt_thumbnail: "", description1: "", brief: "", form_heading: "", form_subtext: "", form_cta_name: "", dynamic_form_title: "", dynamic_form_description: "", media_contact_name: "", media_contact_designation: "", media_contact_email: "",   content: [{ heading: "", description: "", }, { heading: "", description: "", }], faqs: [{ question: "", answer: "" }, { question: "", answer: "" },] });

  // State variables
  const [data, setData] = useState({
    pressrelease: {},
    authors: [],
    tags: [],
  });

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await ApiRequest("GET", filterfetchEndpoint);
        setFilters(response || {});
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        setFilters({});
      }
    };

    fetchFilters();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiRequest("GET", `${EditEndpoint}${pressrelease_id}`,);
        setData(response);
         setPostData((prev) => ({
          ...prev,
          ...response.pressrelease,

          content:
            response?.pressrelease?.content && response?.pressrelease?.content?.length > 0
              ? response?.pressrelease.content
              : prev.content, // keep default

          faqs:
            response?.pressrelease?.faqs && response?.pressrelease?.faqs?.length > 0
              ? response.pressrelease.faqs
              : prev.faqs, // (optional but recommended for consistency)
        }));;

        setSelectedTags(response?.pressrelease?.tagDetails)
        setPreviews((prev) => ({
          ...prev,
          banner_image: BaseUrl + response.pressrelease.banner_image || prev.banner_image,
          thumbnail: BaseUrl + response.pressrelease.thumbnail || prev.thumbnail,
        }));

      } catch (error) {
        console.error("Error fetching blog data:", error);
      }
    };

    fetchData();
  }, [pressrelease_id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];

      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      let updatedValue = value;
      if (name === "date") {
        updatedValue = new Date(value).toISOString();
      }
      setPostData((prev) => ({
        ...prev,
        [name]: updatedValue,
      }));
    }
  };

  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if (key !== "solution_id" && key !== "provider_id" && key !== "specialty_id" && (value === "" || value === null)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

      const hasError = postData.content.some((c, i) => {
          if (!c.heading || !c.description) {
            toast.error(`Content ${i + 1} is incomplete`);
            return true;
          }
          return false;
        });
    
        if (hasError) return;

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      if (key === "faqs" || key === "content") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });

    try {
      const response = await ApiRequest("POST", UpdateEndpoint + pressrelease_id, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.message);
      navigate("/press-release");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };


  // ======================Tags Drag and Drop Functionality========================

  // Accepts array of IDs, array of objects, or comma string
  const handleTagSelectChange = (e) => {
    const { name, value } = e.target; // name should be "tag1"
    let newSelected = [];

    if (Array.isArray(value)) {
      if (value.length > 0 && typeof value[0] === "string") {
        // array of IDs -> map to tag objects from `tags` list
        newSelected = value
          .map((id) => data?.tags.find((t) => t._id === id))
          .filter(Boolean);
      } else {
        // assume array of objects already
        newSelected = value;
      }
    } else if (typeof value === "string") {
      // maybe a comma-separated string "id1,id2"
      const ids = value ? value.split(",").map((s) => s.trim()).filter(Boolean) : [];
      newSelected = ids.map((id) => data?.tags.find((t) => t._id === id)).filter(Boolean);
    } else {
      newSelected = [];
    }

    setSelectedTags(newSelected);

    // keep postData.tag1 as comma string for backend compatibility
    setPostData((prev) => ({
      ...prev,
      [name]: newSelected.map((t) => t._id).join(","),
    }));
  };

  // ------------------ Drag & Drop for tag chips ------------------
  const onDragStartTag = (e, index) => {
    e.dataTransfer.setData("text/plain", String(index));
    e.dataTransfer.effectAllowed = "move";
  };

  const onDragOverTag = (e) => {
    e.preventDefault(); // allow drop
    e.dataTransfer.dropEffect = "move";
  };

  const onDropTag = (e, dropIndex) => {
    e.preventDefault();
    const dragIndexStr = e.dataTransfer.getData("text/plain");
    if (!dragIndexStr) return;
    const dragIndex = parseInt(dragIndexStr, 10);
    if (isNaN(dragIndex) || dragIndex === dropIndex) return;

    setSelectedTags((prev) => {
      const next = Array.from(prev);
      const [moved] = next.splice(dragIndex, 1);
      next.splice(dropIndex, 0, moved);

      const ids = next.map((t) => t._id);
      setPostData((p) => ({
        ...p,
        tag1: ids.join(","),
      }));

      return next;
    });
  };

  const removeTagAt = (index) => {
    setSelectedTags((prev) => {
      const next = prev.filter((_, i) => i !== index);
      const ids = next.map((t) => t._id);
      setPostData((p) => ({
        ...p,
        tag1: ids.join(","),
      }));
      return next;
    });
  };

  const renderSelectedTagsChips = () => {
    if (!selectedTags || selectedTags.length === 0)
      return <div style={{ color: "#666", fontSize: 12, marginTop: 15 }}>SELECTED TAGS: (You can drag and drop them to change their order.)</div>;

    return (
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 15 }}>
        {selectedTags.map((t, i) => (
          <span key={t._id} draggable onDragStart={(e) => onDragStartTag(e, i)} onDragOver={onDragOverTag} onDrop={(e) => onDropTag(e, i)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "6px 10px",
              borderRadius: 16,
              border: "1px solid #d0d0d0",
              background: "#fff",
              cursor: "grab",
              userSelect: "none",
            }}
            title={t.name || t.title}
          >
            <span style={{ fontSize: 13 }}>{t.name || t.title}</span>
            <button type="button" onClick={(ev) => { ev.stopPropagation(); removeTagAt(i); }}
              style={{
                border: "none",
                background: "transparent",
                padding: 0,
                marginLeft: 4,
                cursor: "pointer",
                lineHeight: 1,
                color: "red",
              }}
              aria-label={`Remove ${t.name || t.title}`}
            >
              ✕
            </button>
          </span>
        ))}
      </div>
    );
  };

  // =====================Tag Drag and Drop End===================================

  // =========FAQS Functionality==========

  // 🔹 handle change for question/answer
  const handleFaqChange = (index, field, value) => {
    setPostData((prev) => {
      const updatedFaqs = [...prev.faqs];
      updatedFaqs[index][field] = value;
      return { ...prev, faqs: updatedFaqs };
    });
  };

  // 🔹 add new FAQ
  const addFaq = () => {
    setPostData((prev) => ({
      ...prev,
      faqs: [...prev.faqs, { question: "", answer: "" }],
    }));
  };

  // 🔹 remove FAQ
  const removeFaq = (index) => {
    setPostData((prev) => ({
      ...prev,
      faqs: prev.faqs.filter((_, i) => i !== index),
    }));
  };

  // =======FAQs Functionality End==========


   // =======Content Functionality End==========

  const handleContentChange = (index, field, value) => {
    setPostData((prev) => {
      const updatedContent = [...prev.content];
      updatedContent[index][field] = value;
      return { ...prev, content: updatedContent };
    });
  };

  const addContent = () => {
    setPostData((prev) => ({
      ...prev,
      content: [...prev.content, { heading: "", description: "" }],
    }));
  };

  const removeContent = (index) => {
    setPostData((prev) => ({
      ...prev,
      content: prev.content.filter((_, i) => i !== index),
    }));
  };

  // =======Content Functionality End==========




  const pagename = {
    name: 'PR Management',
    user: 'Admin',
    innerpage: 'PR Management / PR / Edit PR'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form id="blogEdit" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input value={postData?.title} onChange={handleChange} name="title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input value={postData?.slug} onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Date<small>*</small></label>
                  </div>
                  <input value={postData.date ? new Date(postData.date).toISOString().split("T")[0] : ""} onChange={handleChange} name="date" type="date" className="form-control" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Author Name<small>*</small></label>
                  </div>
                  <CustomSelect defaultValue={postData?.author_id} onChange={handleChange} name="author_id" options={data.authors} placeholder="Select Author Name" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Solution<small></small></label>
                  </div>
                  <CustomSelect multiple defaultValue={postData?.solution_id} onChange={handleChange} name="solution_id" options={filters?.solutions} placeholder="Select solution" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Specialty<small></small></label>
                  </div>
                  <CustomSelect multiple defaultValue={postData?.specialty_id} onChange={handleChange} name="specialty_id" options={filters?.specialities} placeholder="Select specialty" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Provider<small></small></label>
                  </div>
                  <CustomSelect multiple defaultValue={postData?.provider_id} onChange={handleChange} name="provider_id" options={filters?.providers} placeholder="Select provider" />
                </div>
              </div>

              {/* Tag1: MULTIPLE + DRAGGABLE CHIPS */}
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>
                      Select Tags<small>*</small>
                    </label>
                  </div>

                  <CustomSelect multiple defaultValue={postData.tag1} onChange={handleTagSelectChange} name="tag1" options={data.tags} placeholder="Select Tag Name" />

                  {/* Selected tags shown as draggable spans */}
                  {renderSelectedTagsChips()}
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Short Description<small>*</small></label>
                  </div>
                  <input value={postData.brief} onChange={handleChange} name="brief" type="text" className="form-control" placeholder="Short Description" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> First Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.description1} onChange={(event, editor) => handleEditorChange("description1", editor.getData())} />
                </div>
              </div>

              {/* <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>h2 title <small>*</small></label>
                  </div>
                  <input value={postData.h2_title} onChange={handleChange} name="h2_title" type="text" className="form-control" placeholder="H2 Title" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> h2 Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.h2_description} onChange={(event, editor) => handleEditorChange("h2_description", editor.getData())} />
                </div>
              </div> */}
            </div>
          </div>

              <div className="add-content-wrap">
                      <h5>Content Section</h5>
                      <div className="row">
          
                        {postData?.content?.map((item, index) => (
                          <div key={index} className="col-lg-6" style={{ position: "relative" }}>
          
                            <div className="add-page-inputs">
                              <div className="label-wrap-add">
                                <label>Heading<small>*</small></label>
                              </div>
                              <input type="text" className="form-control" value={item.heading}
                                onChange={(e) => handleContentChange(index, "heading", e.target.value)} placeholder={`Heading ${index + 1}`} />
                            </div>
          
                            <div className="add-page-inputs">
                              <div className="label-wrap-add">
                                <label>Description<small>*</small></label>
                              </div>
                              <DynamicCKEditor data={item.description} onChange={(event, editor) => handleContentChange(index, "description", editor.getData())} />
                            </div>
          
                            {index > 1 && (
                              <button type="button" onClick={() => removeContent(index)} style={{ position: "absolute", background: "linear-gradient(270deg,#e20814,#a80008)", top: "5px", right: "10px", color: "#fff", border: "none", borderRadius: "8px", fontSize: "12px", padding: "3px 15px" }}>
                                REMOVE
                              </button>
                            )}
                          </div>
                        ))}
          
                        <div className="col-lg-12 text-center">
                          <button type="button" onClick={addContent} style={{ background: "green", top: "5px", right: "10px", color: "#fff", border: "none", borderRadius: "8px", fontSize: "14px", padding: "5px 15px", marginTop: "15px" }}>
                            Add Content
                          </button>
                        </div>
                      </div>
                    </div>
                    

          {/* <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>h3 title <small>*</small></label>
                  </div>
                  <input value={postData.h3_title} onChange={handleChange} name="h3_title" type="text" className="form-control" placeholder="H3 Title" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> h3 Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.h3_description} onChange={(event, editor) => handleEditorChange("h3_description", editor.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>h4 title <small>*</small></label>
                  </div>
                  <input value={postData.h4_title} onChange={handleChange} name="h4_title" type="text" className="form-control" placeholder="H4 Title" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> h4 Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.h4_description} onChange={(event, editor) => handleEditorChange("h4_description", editor.getData())} />
                </div>
              </div>


            </div>
          </div> */}

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Media Contact Name<small>*</small></label>
                  </div>
                  <input value={postData.media_contact_name} onChange={handleChange} name="media_contact_name" type="text" className="form-control" placeholder="Media Contact Name" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Media Contact Designation<small>*</small></label>
                  </div>
                  <input value={postData.media_contact_designation} onChange={handleChange} name="media_contact_designation" type="text" className="form-control" placeholder="Media Contact Designation" />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Media Contact Email<small>*</small></label>
                  </div>
                  <input value={postData.media_contact_email} onChange={handleChange} name="media_contact_email" type="text" className="form-control" placeholder="Media Contact Email" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Form   Title<small>*</small></label>
                  </div>
                  <input type="text" className="form-control" name="form_heading" onChange={handleChange} value={postData.form_heading} />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Form  Subtext<small>*</small></label>
                  </div>
                  <input type="text" className="form-control" name="form_subtext" onChange={handleChange} value={postData.form_subtext} />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Form  Button Text <small>*</small></label>
                  </div>
                  <input type="text" className="form-control" name="form_cta_name" onChange={handleChange} value={postData.form_cta_name} />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Form Left Title<small>*</small></label>
                  </div>
                  <input type="text" className="form-control" name="dynamic_form_title" onChange={handleChange} value={postData.dynamic_form_title} />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Form Left Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.dynamic_form_description} onChange={(event, editor) => handleEditorChange("dynamic_form_description", editor.getData())} />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Banner Image Alt Tag<small>*</small></label>
                  </div>
                  <input value={postData.alt_banner_image} onChange={handleChange} name="alt_banner_image" type="text" className="form-control" placeholder="alt banner" />
                </div>

                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Banner Image (1608 × 601)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="banner_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.banner_image}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Thumbnail Image Alt Tag<small>*</small></label>
                  </div>
                  <input value={postData.alt_thumbnail} onChange={handleChange} name="alt_thumbnail" type="text" className="form-control" placeholder="alt thumbnail" />
                </div>

                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Thumbnail Image (508 × 308)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="thumbnail"
                    // maxSize={550 * 1024}
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.thumbnail} />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <h5>Faq Section</h5>
            <div className="row">

              {postData.faqs.map((faq, index) => (
                <div key={index} className="col-lg-6" style={{ position: "relative" }}>
                  <div className="add-page-inputs input-add-image">
                    <div className="label-wrap-add">
                      <label>Question<small>*</small></label>
                    </div>
                    <input required className="form-control" type="text" placeholder={`Question ${index + 1}`} value={faq.question} onChange={(e) => handleFaqChange(index, "question", e.target.value)} />
                  </div>

                  <div className="add-page-inputs input-add-image">
                    <div className="label-wrap-add">
                      <label>Answer<small>*</small></label>
                    </div>
                    <DynamicCKEditor data={faq.answer} onChange={(event, editor) => handleFaqChange(index, "answer", editor.getData())} />
                  </div>
                  {index >= 2 && (
                    <button type="button" style={{ position: "absolute", background: "linear-gradient(270deg,#e20814,#a80008)", top: "5px", right: "10px", color: "#fff", border: "none", borderRadius: "8px", fontSize: "12px", padding: "3px 15px" }} onClick={() => removeFaq(index)}>
                      REMOVE
                    </button>
                  )}
                </div>
              ))}

              <div className="col-lg-12 text-center">
                <button type="button" className="add-faqs" onClick={addFaq} style={{ background: "green", top: "5px", right: "10px", color: "#fff", border: "none", borderRadius: "8px", fontSize: "14px", padding: "5px 15px", marginTop: "15px" }}>
                  Add New Faq
                </button>
              </div>
            </div>
          </div>
        </form>

        <button type="submit" form="blogEdit" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}

